<template>
  <div>
    <v-form>
      <v-text-field
        v-model="login"
        :label="$t('login.placeholder')"
        outlined
        name="login"
        type="text"
        autocomplete="username"
        class="body-2"
        :disabled="disabled"
        @keyup.enter="loginMethod"
      >
        <template #prepend-inner>
          <v-icon small class="pt-1 pr-2">fa-user</v-icon>
        </template>
      </v-text-field>

      <v-text-field
        v-model="password"
        :label="$t('login.password')"
        outlined
        name="password"
        type="password"
        autocomplete="current-password"
        class="body-2"
        :disabled="disabled"
        @keyup.enter="loginMethod"
      >
        <template #prepend-inner>
          <v-icon small class="pt-1 pr-2">fa-key</v-icon>
        </template>
      </v-text-field>
    </v-form>

    <div class="d-flex align-center justify-space-between" style="flex-flow: column">
      <!-- REMEMBER ME -->
      <v-checkbox :label="$t('login.rememberMe')" v-model="checkbox_remember_me" />
      <!-- FORGOTPASSWORD -->
      <a v-if="notEmptyForgotPassword || isInEditorMode" @click="forgotPassword">
        {{ evaluateExpression(model.ForgotPasswordCaption) }}
      </a>
      <!-- SIGNIN BUTTON -->
      <v-btn color="primary" @click="loginMethod" :loading="loading" :disabled="loading">
        {{ $t('login.signInButton') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import inputMixin from '../../mixins/input-mixin'

  export default {
    props: ['disabled', 'model', 'isInEditorMode', 'loading'],

    mixins: [inputMixin],

    data: () => ({
      login: '',
      password: '',
      checkbox_remember_me: false
    }),

    computed: {
      notEmptyForgotPassword() {
        return this.model.ForgotPasswordUrl && this.model.ForgotPasswordUrl.length > 0
      }
    },

    methods: {
      forgotPassword() {
        window.open(this.model.ForgotPasswordUrl)
      },

      loginMethod() {
        if (!this.login || !this.password) {
          this.$store.commit('SET_ERROR', this.$t('login.signInFormIsEmpty'))
          return
        }

        this.$authCore.SignIn({
          email: this.login,
          password: this.password,
          keepSigned: this.checkbox_remember_me
        })
      }
    }
  }
</script>
